export const DISTRIBUTION_POLICIES = ['distributed', 'accumulated'] as const

export type DistributionPolicy = (typeof DISTRIBUTION_POLICIES)[number]

export const DISTRIBUTION_POLICY_LABELS: Record<DistributionPolicy, string> = {
  distributed: 'Distributed',
  accumulated: 'Accumulated',
}

export const DISTRIBUTION_POLICY_OPTIONS = DISTRIBUTION_POLICIES.map((t) => ({
  label: DISTRIBUTION_POLICY_LABELS[t],
  value: t,
})).sort()
